/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Timeline/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TimelineEvent from 'DesignSystem/TimelineEvent/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Timeline({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Timeline"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let eventsValueData = fromData.useDataValue({ viewPath,
context: 'events',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Timeline.Horizontal"
  data-view-path={viewPath}
 style={{'--mw-1-Z2njcxS': isMedia.mobile ? "100%" : "990px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Timeline.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mb-2-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Timeline.Horizontal:2"
  data-view-path={viewPath}
 style={{'--pt-3-Z2njcxS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="START OF THE TREATMENT"
 level="h4"
 color={dtColorsNeutral500}
/>
</div>
</div>
</div>
<div
  data-testid="Timeline.Vertical"
  data-view-path={viewPath}
 style={{'--bc-4-Z2njcxS': dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Timeline.List"
  data-view-path={viewPath}
 style={{'--pb-5-Z2njcxS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mw-1-Z2njcxS': isMedia.mobile ? "100%" : "990px"}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(eventsValueData) && eventsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="event"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TimelineEvent(${item?.id ?? item?._id ?? index})`}
      >
<TimelineEvent
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TimelineEvent(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }